import * as fromDatatype from '../datatype-library/index';

export interface app_login_mfa_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    account_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    name_first: fromDatatype.VarcharDatatypeInterface;
    name_last: fromDatatype.VarcharDatatypeInterface;
    main_email: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    gender: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    app_login_mfa_reset_guid: fromDatatype.GuidDataFieldInterface;
}

export class app_login_mfa_RowClass implements app_login_mfa_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    account_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    name_first: fromDatatype.VarcharDatatypeInterface;
    name_last: fromDatatype.VarcharDatatypeInterface;
    main_email: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    gender: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    app_login_mfa_reset_guid: fromDatatype.GuidDataFieldInterface;
}